import React from "react";
import Filter from "../../pages/DashBoard/filter";
import { useSelector } from "react-redux";
import ListingsSearchFilter from "../../pages/DashBoard/ListingsSearch/listingsSearchFilter";

const FilterSection = ({
  selectedCardData,
  getMatchingProfilesCon,
  formResetFlag,
  getMatchingProfiles,
  getMatchingBankingListings,
  setFIlterModal,
}) => {
  const role = useSelector((state) => state?.sessionState?.role);

  return (
    <div>
      {role !== "BANKING" ? (
        <Filter
          formResetFlag={formResetFlag}
          selectedCardData={selectedCardData}
          getMatchingProfilesCon={getMatchingProfilesCon}
          getMatchingProfiles={getMatchingProfiles}
          setFIlterModal={setFIlterModal}
        />
      ) : (
        <ListingsSearchFilter
          getMatchingBankingListings={getMatchingBankingListings}
          selectedCardData={selectedCardData}
        />
      )}
    </div>
  );
};

export default FilterSection;
